<template>
  <div id="app" class="mt-0">
    <!-- IMAGES PORTFOLIO -->
    <!-- PIXEL -->
    <div class="row container-fluid d-flex justify-content-center m-0 p-0 folioimages" v-if="pixel">
      <div class="row col-10 bg-dark pt-2 pb-3 contenuimg">
        <div class="col-12 text-right text-white mb-3 p-0">
          <h3 style="display:inline-block" v-on:click="pixol">X</h3>
        </div>
        <div class="col-4 p-0 pr-1">
          <img :src="pixun" alt="port" />
        </div>
        <div class="col-2 p-0 pl-1">
          <div class="col-3 p-0">
            <img
              :src="pixdeux"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=pixun; pixun=pixdeux; pixdeux=stock"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="pixtrois"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=pixun; pixun=pixtrois; pixtrois=stock"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="pixquatre"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=pixun; pixun=pixquatre; pixquatre=stock"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="pixcinq"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=pixun; pixun=pixcinq; pixcinq=stock"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="pixsix"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=pixun; pixun=pixsix; pixsix=stock"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="pixsept"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=pixun; pixun=pixsept; pixsept=stock"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="pixhuit"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=pixun; pixun=pixhuit; pixhuit=stock"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="pixneuf"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=pixun; pixun=pixneuf; pixneuf=stock"
            />
          </div>
        </div>
        <div class="col-6 m-0 p-0 text-white">
          <h1 style="font-size:1.5vw">Pixel art :</h1>
          <br />
          <h4
            class="text-left"
            style="font-size:1vw"
          >J'utilise le logiciel Aseprite pour réaliser du pixel art. C'est un style que j'aime et que je travaille beaucoup, réminiscent des vieux jeux vidéos. J'ai une bonne maîtrise de cette technique et je peux aussi réaliser des animations fluides.</h4>
        </div>
      </div>
    </div>
    <!-- FIN PIXEL -->
    <!-- DEV -->
    <div class="row container-fluid d-flex justify-content-center m-0 p-0 folioimages" v-if="dev">
      <div class="row col-10 bg-dark pt-2 pb-3 contenuimg">
        <div class="col-12 text-right text-white mb-3 p-0">
          <h3 style="display:inline-block" v-on:click="deve">X</h3>
        </div>
        <div class="col-4 p-0 pr-1">
          <img :src="devun" alt="port" />
          <br />
          <a v-if="voir" :href="site" target="blank">
            <h3>Voir le site</h3>
          </a>
        </div>
        <div class="col-2 p-0 pl-1">
          <div class="col-3 p-0">
            <img
              :src="devdeux"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=devun; devun=devdeux; devdeux=stock; lien()"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="devtrois"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=devun; devun=devtrois; devtrois=stock; lien()"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="devquatre"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=devun; devun=devquatre; devquatre=stock; lien()"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="devsix"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=devun; devun=devsix; devsix=stock; lien()"
            />
          </div>
        </div>
        <div class="col-6 m-0 p-0 text-white">
          <h2 style="font-size:1.5vw">Développement web :</h2>
          <br />
          <h4
            class="text-left"
            style="font-size:1vw"
          >En utlisant mes connaissance en HTML, CSS, JS et PHP, j'ai réalisé des sites web avec comme ligne directrice la narration interactive. Je maîtrise la full-stack VueJS/Laravel et je suis enthousiaste pour découvrir de nouvelles manières de coder.</h4>
        </div>
      </div>
    </div>
    <!-- FIN DEV -->
    <!-- GRAPH -->
    <div class="row container-fluid d-flex justify-content-center m-0 p-0 folioimages" v-if="graph">
      <div class="row col-10 bg-dark pt-2 pb-3 contenuimg">
        <div class="col-12 text-right text-white mb-3 p-0">
          <h3 style="display:inline-block" v-on:click="graphi">X</h3>
        </div>
        <div class="col-4 p-0 pr-1">
          <img :src="graun" alt="port" />
        </div>
        <div class="col-2 p-0 pl-1">
          <div class="col-3 p-0">
            <img
              :src="gradeux"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=graun; graun=gradeux; gradeux=stock"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="gratrois"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=graun; graun=gratrois; gratrois=stock"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="graquatre"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=graun; graun=graquatre; graquatre=stock"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="gracinq"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=graun; graun=gracinq; gracinq=stock"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="grasept"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=graun; graun=grasept; grasept=stock"
            />
          </div>
        </div>
        <div class="col-6 m-0 p-0 text-white">
          <h1 style="font-size:1.5vw">Graphisme :</h1>
          <br />
          <h4
            class="text-left"
            style="font-size:1vw"
          >J'ai effectué divers travaux de graphisme pour animer des images ou créer des bannières pour des évènements. Je peux également animer des images que je n'ai pas réalisé.</h4>
        </div>
      </div>
    </div>
    <!-- FIN GRAPH -->
    <!-- ANIM -->
    <div class="row container-fluid d-flex justify-content-center m-0 p-0 folioimages" v-if="anim">
      <div class="row col-10 bg-dark pt-2 pb-3 contenuimg">
        <div class="col-12 text-right text-white mb-3 p-0">
          <h3 style="display:inline-block" v-on:click="anima">X</h3>
        </div>
        <div class="col-4 p-0 pr-1">
          <img :src="aniun" alt="port" />
          <br />
          <a v-if="see" href="https://www.youtube.com/watch?v=PEACiWCpNTg" target="blank">
            <h3>Voir la vidéo</h3>
          </a>
        </div>
        <div class="col-2 p-0 pl-1">
          <div class="col-3 p-0">
            <img
              :src="anideux"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=aniun; aniun=anideux; anideux=stock; vid()"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="anitrois"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=aniun; aniun=anitrois; anitrois=stock; vid()"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="aniquatre"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=aniun; aniun=aniquatre; aniquatre=stock; vid()"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="anicinq"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=aniun; aniun=anicinq; anicinq=stock; vid()"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="anisept"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=aniun; aniun=anisept; anisept=stock; vid()"
            />
          </div>
          <div class="col-3 p-0">
            <img
              :src="anineuf"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=aniun; aniun=anineuf; anineuf=stock; vid()"
            />
          </div>
        </div>
        <div class="col-6 m-0 p-0 text-white">
          <h1 style="font-size:1.5vw">Animations :</h1>
          <br />
          <h4
            class="text-left"
            style="font-size:1vw"
          >Grâce à mon utilisation de logiciels comme Aseprite, Photoshop et Sony Vegas, je peux réaliser des animations et des vidéos. J'ai de l'expérience en animation en image par image et en montage vidéo.</h4>
        </div>
      </div>
    </div>
    <!-- FIN ANIM -->
    <!-- GRIBOU -->
    <div
      class="row container-fluid d-flex justify-content-center m-0 p-0 folioimages"
      v-if="gribou"
    >
      <div class="row col-10 bg-dark pt-2 pb-3 contenuimg">
        <div class="col-12 text-right text-white mb-3 p-0">
          <h3 style="display:inline-block" v-on:click="gribouz">X</h3>
        </div>
        <div class="col-5 p-0 pr-1">
          <img :src="griun" alt="port" />
        </div>
        <div class="col-1 p-0 pl-1">
          <div class="col-7 p-0">
            <img
              :src="grideux"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=griun; griun=grideux; grideux=stock"
            />
          </div>
          <div class="col-7 p-0">
            <img
              :src="gritrois"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=griun; griun=gritrois; gritrois=stock"
            />
          </div>
          <div class="col-7 p-0">
            <img
              :src="griquatre"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=griun; griun=griquatre; griquatre=stock"
            />
          </div>
          <div class="col-7 p-0">
            <img
              :src="gricinq"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=griun; griun=gricinq; gricinq=stock"
            />
          </div>
          <div class="col-7 p-0">
            <img
              :src="grisix"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=griun; griun=grisix; grisix=stock"
            />
          </div>
          <div class="col-7 p-0">
            <img
              :src="grisept"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=griun; griun=grisept; grisept=stock"
            />
          </div>
          <div class="col-7 p-0">
            <img
              :src="grihuit"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=griun; griun=grihuit; grihuit=stock"
            />
          </div>
          <div class="col-7 p-0">
            <img
              :src="grineuf"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=griun; griun=grineuf; grineuf=stock"
            />
          </div>
        </div>
        <div class="col-6 m-0 p-0 text-white">
          <h1 style="font-size:1.5vw">Gribouzine :</h1>
          <br />
          <h4
            class="text-left"
            style="font-size:1vw"
          >Le Gribouzine est un magazine auto-édité, réalisé avec Amélie Pécot et Christopher Boyd. Financé sur Ulule via une campagne de crowdfunding, ce projet m'a permis de me lancer dans une expérience très enrichissante qui m'a ouvert à tous les aspects de la production d'un magazine (maquette, design, création de produits dérivés etc...)</h4>
        </div>
      </div>
    </div>
    <!--FIN GRIBOU -->
    <!-- ILLU -->
    <div class="row container-fluid d-flex justify-content-center m-0 p-0 folioimages" v-if="illu">
      <div class="row col-10 bg-dark pt-2 pb-3 contenuimg">
        <div class="col-12 text-right text-white mb-3 p-0">
          <h3 style="display:inline-block" v-on:click="illustr">X</h3>
        </div>
        <div class="col-5 p-0 pr-1">
          <img :src="illun" alt="port" />
        </div>
        <div class="col-1 p-0 pl-1">
          <div class="col-8 p-0">
            <img
              :src="illdeux"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=illun; illun=illdeux; illdeux=stock"
            />
          </div>
          <div class="col-8 p-0">
            <img
              :src="illtrois"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=illun; illun=illtrois; illtrois=stock"
            />
          </div>
          <div class="col-8 p-0">
            <img
              :src="illquatre"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=illun; illun=illquatre; illquatre=stock"
            />
          </div>
          <div class="col-8 p-0">
            <img
              :src="illcinq"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=illun; illun=illcinq; illcinq=stock"
            />
          </div>
          <div class="col-8 p-0">
            <img
              :src="illsept"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=illun; illun=illsept; illsept=stock"
            />
          </div>
          <div class="col-8 p-0">
            <img
              :src="illhuit"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=illun; illun=illhuit; illhuit=stock"
            />
          </div>
          <div class="col-8 p-0">
            <img
              :src="illneuf"
              alt="port"
              style="cursor:pointer"
              v-on:click="stock=illun; illun=illneuf; illneuf=stock"
            />
          </div>
        </div>
        <div class="col-6 m-0 p-0 text-white">
          <h1 style="font-size:1.5vw">Illustration :</h1>
          <br />
          <h4
            class="text-left"
            style="font-size:1vw"
          >Je réalise des illustrations avec des styles et thèmes variés. Je maîtrise différentes techniques de dessin traditionnel (crayon, peinture, encrage etc...) et j'aime apporter à ces techniques un apport numérique à la palette graphique. Je travaille majoritairement sur photoshop et je peux aussi y réaliser des illustrations 100% numériques.</h4>
        </div>
      </div>
    </div>
    <!--FIN ILLU -->
    <div class="pc" v-if="!mobile">
      <div class="pinContainer" ref="pin">
        <section
          :key="(p,index)"
          v-for="(p, index) in panels"
          class="panel"
          :class="`panel-${index}`"
        >
          <div class="essai">
            <h1>{{p.coco}}</h1>
          </div>
          <div class="essai2">
            <h4>{{p.co}}</h4>
          </div>
          <div class="row d-flex container-fluid justify-content-center">
            <div :class="p.card" class="col-9 row d-flex container-fluid justify-content-center">
              <!-- PAGE 2 -->
              <div v-if="p.card == 'one'">
                <div class="row d-flex container-fluid justify-content-center">
                  <div class="col-12">
                    <img src="../src/assets/img/panel1fr.png" alt="port" />
                  </div>
                </div>
              </div>
              <!-- PAGE 2 -->
              <!-- PAGE 3 -->
              <div v-if="p.card == 'two'">
                <div>
                  <img src="../src/assets/img/panel2fr.png" alt="port" />
                </div>
                <div class="mb-5 mt-4">
                  <a
                    href="https://pdfhost.io/v/B7iGV6tXR_corentin_pelaprat_2019pdf.pdf"
                    target="blank"
                    class="download p-3 text-dark"
                  >Télécharger CV</a>
                </div>
              </div>
              <!-- PAGE 3 -->
              <div v-if="p.card == 'four'">
                <div class="row d-flex container-fluid justify-content-around">
                  <div class="col-10 row d-flex container-fluid justify-content-around">
                    <div class="col-12 titre pt-3">
                      <h1>PORTFOLIO</h1>
                    </div>
                    <div
                      class="col-3 p-0 mb-3 mt-3 position-relative"
                      style="cursor:pointer"
                      v-on:click="gribouz"
                    >
                      <div
                        class="position-absolute folpixel"
                        style="max-width:100%;max-height:100%"
                      >
                        <h4 style="margin-top:30%; font-size:1vw">Gribouzine</h4>
                        <img
                          src="../src/assets/img/Book_mockup_gribou.png"
                          alt="fol"
                          style="visibility:hidden"
                        />
                      </div>
                      <img src="../src/assets/img/Book_mockup_gribou.png" alt="fol" />
                    </div>
                    <div
                      class="col-3 p-0 mb-3 mt-3 position-relative"
                      style="cursor:pointer"
                      v-on:click="anima"
                    >
                      <div
                        class="position-absolute folpixel"
                        style="max-width:100%;max-height:100%"
                      >
                        <h4 style="margin-top:30%; font-size:1vw">Animations</h4>
                        <img
                          src="../src/assets/img/norbocosmo.gif"
                          alt="fol"
                          style="visibility:hidden"
                        />
                      </div>
                      <img src="../src/assets/img/norbocosmo.gif" alt="fol" />
                    </div>
                    <div
                      class="col-3 p-0 mb-3 mt-3 position-relative"
                      style="cursor:pointer"
                      v-on:click="graphi"
                    >
                      <div
                        class="position-absolute folpixel"
                        style="max-width:100%;max-height:100%"
                      >
                        <h5 style="margin-top:30%; font-size:1vw">Graphisme</h5>
                        <img src="../src/assets/img/tourbi.gif" alt="fol" style="visibility:hidden" />
                      </div>
                      <img src="../src/assets/img/tourbi.gif" alt="fol" />
                    </div>
                    <div class="col-12"></div>
                    <div
                      class="col-3 p-0 mb-3 position-relative"
                      v-on:click="pixol"
                      style="cursor:pointer"
                    >
                      <div
                        class="position-absolute folpixel"
                        style="max-width:100%;max-height:100%"
                      >
                        <h4 style="margin-top:30%; font-size:1vw">Pixel art</h4>
                        <img src="../src/assets/img/grabu.png" alt="fol" style="visibility:hidden" />
                      </div>
                      <img src="../src/assets/img/grabu.png" alt="fol" />
                    </div>
                    <div
                      class="col-3 p-0 mb-3 position-relative"
                      style="cursor:pointer"
                      v-on:click="illustr"
                    >
                      <div
                        class="position-absolute folpixel"
                        style="max-width:100%;max-height:100%"
                      >
                        <h4 style="margin-top:30%; font-size:1vw">Illustration</h4>
                        <img src="../src/assets/img/dtiys.png" alt="fol" style="visibility:hidden" />
                      </div>
                      <img src="../src/assets/img/dtiys.png" alt="fol" />
                    </div>
                    <div
                      class="col-3 p-0 mb-3 position-relative"
                      style="cursor:pointer"
                      v-on:click="deve"
                    >
                      <div
                        class="position-absolute folpixel"
                        style="max-width:100%;max-height:100%"
                      >
                        <h4 style="margin-top:30%; font-size:1vw">Développement web</h4>
                        <img
                          src="../src/assets/img/Capture d’écran de 2019-03-19 10-49-00.png"
                          alt="fol"
                          style="visibility:hidden"
                        />
                      </div>
                      <img
                        src="../src/assets/img/Capture d’écran de 2019-03-19 10-49-00.png"
                        alt="fol"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- PAGE 4 -->
              <div v-if="p.card == 'tree'">
                <div class="row">
                  <div class="col-12 mb-3 mt-3">
                    <h1 class="titre">CONTACT :</h1>
                  </div>
                  <div class="col-5 text-dark text-left row">
                    <h3 class="col-12 mb-3">Me contacter :</h3>
                    <h6 class="col-12">
                      <span>Pays :</span> Belgique
                    </h6>
                    <h6 class="col-12">
                      <span>Email :</span> corentin.pelaprat@gmail.com
                    </h6>
                    <h6 class="col-12">
                      <span>Téléplhone :</span> +33 7 81 08 77 10
                    </h6>
                    <h6 class="col-12">
                      <span>Adresse :</span> 18 Rue Amedée Lynen, 1210, Bruxelles, Belgique
                    </h6>
                    <h6 class="col-12">
                      <span>Emploi :</span> Disponible
                    </h6>
                  </div>
                  <div
                    class="col-7 text-dark text-left row d-flex container-fluid justify-content-center"
                  >
                    <h3 class="col-12">Contact :</h3>
                    <form
                      action="https://formspree.io/corentin.pelaprat@gmail.com"
                      target="blank"
                      method="POST"
                      class="col-10 row d-flex container-fluid justify-content-center"
                    >
                      <input
                        type="text"
                        name="Name"
                        class="col-5 mr-1"
                        placeholder="Nom"
                        v-model="nom"
                      />

                      <input
                        type="text"
                        name="Email"
                        id="Email"
                        class="col-5 ml-1"
                        placeholder="E-mail"
                        v-model="email"
                      />

                      <textarea
                        name="Message"
                        class="col-12 mt-3 mb-3"
                        id="Message"
                        v-model="message"
                      ></textarea>

                      <input
                        type="submit"
                        value="Envoyer"
                        class="col-4 mb-3 download mr-1"
                        v-if="nom!=='' && email!=='' && message!==''"
                      />
                      <input type="reset" value="Reset" class="col-4 mb-3 download ml-1" />
                    </form>
                  </div>
                </div>
              </div>
              <!-- PAGE 4 -->
            </div>
          </div>
        </section>
        <div class="mont1"></div>
        <div class="mont2"></div>
        <div class="sol"></div>
        <div class="ciel"></div>
      </div>
      <div class="norbert">
        <img :src="norbert" alt="norb" />
      </div>
    </div>
    <div class="mobile" v-if="mobile">
      <div class="row d-flex container-fluid justify-content-center p-0 m-0">
        <div class="col-12 row d-flex container-fluid justify-content-center">
          <h1 class="mt-3 text-white">Corentin Pelaprat</h1>
          <h4 class="mb-3 text-white">Full-stack developer, Web designer, Illustrateur</h4>
          <!-- PAGE 1 -->
          <div>
            <div class="row d-flex container-fluid justify-content-center m-0">
              <div class="col-12">
                <img src="../src/assets/img/panel1fr.png" alt="port" />
              </div>
            </div>
          </div>
          <!-- PAGE 2 -->
          <!-- PAGE 3 -->
          <div>
            <div class="row d-flex justify-content-center container-fluid m-0">
              <div class="row page1 mt-5">
                <img src="../src/assets/img/panel2fr.png" alt="port" />
                <div class="col-12 mb-5 mt-4 justify-content-center">
                  <a
                    href="https://pdfhost.io/v/B7iGV6tXR_corentin_pelaprat_2019pdf.pdf"
                    class="download p-3 text-dark"
                  >Télécharger CV</a>
                </div>
              </div>
            </div>
          </div>
          <!-- PAGE 3 -->
          <!-- PAGE 4 -->
          <div>
            <div class="row container-fluid page1 mt-5 ml-0 mb-5">
              <div class="col-12 mb-3 mt-3">
                <h1 class="titre">CONTACT :</h1>
              </div>
              <div class="col-5 text-dark text-left row">
                <h3 class="col-12 mb-3">Me contacter :</h3>
                <h6 class="col-12">
                  <span>Pays :</span> Belgique
                </h6>
                <h6 class="col-12">
                  <span>Email :</span> corentin.pelaprat@gmail.com
                </h6>
                <h6 class="col-12">
                  <span>Téléphone :</span> +33 7 81 08 77 10
                </h6>
                <h6 class="col-12">
                  <span>Adresse :</span> 18 Rue Amedée Lynen, 1210, Bruxelles, Belgique
                </h6>
                <h6 class="col-12">
                  <span>Emploi :</span> Disponible
                </h6>
              </div>
              <div
                class="col-7 text-dark text-left row d-flex container-fluid justify-content-center"
              >
                <h3 class="col-12">Contact :</h3>
                <form
                  action="https://formspree.io/corentin.pelaprat@gmail.com"
                  target="blank"
                  method="POST"
                  class="col-10 row d-flex container-fluid justify-content-center"
                >
                  <input type="text" name="Name" class="col-5 mr-1" placeholder="Nom" v-model="nom" />

                  <input
                    type="text"
                    name="Email"
                    id="Email"
                    class="col-5 ml-1"
                    placeholder="E-mail"
                    v-model="email"
                  />

                  <textarea name="Message" class="col-12 mt-3 mb-3" id="Message" v-model="message"></textarea>

                  <input
                    type="submit"
                    value="Envoyer"
                    class="col-4 mb-3 download mr-1"
                    v-if="nom!=='' && email!=='' && message!==''"
                  />
                  <input type="reset" value="Reset" class="col-4 mb-3 download ml-1" />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
        

<script>
import Folio from "./projets/folio";
export default {
  mounted() {
    var that = this;
    this.$nextTick(this.pinContainerScene);
    window.addEventListener("scroll", that.responsive);
    if (window.innerWidth < 845 || window.innerHeight < 500) {
      that.mobile = true;
      that.pc = false;
      that.on = true;
      if (that.mob == false) {
        that.$nextTick(that.pinContainerScene);
      }
    } else if (window.innerWidth > 845 || window.innerHeight > 500) {
      that.mobile = false;
      that.mob = false;
      window.addEventListener("scroll", that.scrolling);
      if (that.pc == false) {
        that.$nextTick(that.pinContainerScene);
      }
    }
    window.onresize = function() {
      if (window.innerWidth < 845 || window.innerHeight < 500) {
        that.mobile = true;
        that.pc = false;
        if (that.mob == false) {
          window.removeEventListener("scroll", that.scrolling);
          that.$nextTick(that.pinContainerScene);
        }
      } else if (window.innerWidth > 845 || window.innerHeight > 500) {
        that.mobile = false;
        that.mob = false;
        that.on = false;
        if (that.pc == false) {
          window.addEventListener("scroll", that.scrolling);
          that.$nextTick(that.pinContainerScene);
        }
      }
    };
  },
  data() {
    return {
      test: "bg-danger p-5 norbert",
      scrollcount: 0,
      final: "0%",
      norbert: require("../src/assets/img/norbert.gif"),
      timer: null,
      nom: "",
      email: "",
      message: "",
      mob: false,
      mobile: false,
      pc: true,
      on: false,
      stock: "",
      pixun: require("./assets/img/grabu.png"),
      pixdeux: require("./assets/img/rex.png"),
      pixtrois: require("./assets/img/sheya.png"),
      pixquatre: require("./assets/img/capt.png"),
      pixcinq: require("./assets/img/flora.png"),
      pixsix: require("./assets/img/testreggie.png"),
      pixsept: require("./assets/img/Peko faceset.png"),
      pixhuit: require("./assets/img/Thorn faceset.png"),
      pixneuf: require("./assets/img/Berthe faceset.png"),
      griun: require("./assets/img/2b72fd6e2e67787e1084e265a5d5a27b.jpg"),
      grideux: require("./assets/img/Sans titre-2.png"),
      gritrois: require("./assets/img/Sans titre-3.png"),
      griquatre: require("./assets/img/Sans titre-4.png"),
      gricinq: require("./assets/img/Sans titre-1.png"),
      grisix: require("./assets/img/Sans titre-5.png"),
      grisept: require("./assets/img/Sans titre-6.png"),
      grihuit: require("./assets/img/Sans titre-9.png"),
      grineuf: require("./assets/img/Sans titre-8.png"),
      illun: require("./assets/img/dtiys.png"),
      illdeux: require("./assets/img/dtiys demon.png"),
      illtrois: require("./assets/img/norbotest.png"),
      illquatre: require("./assets/img/sabot.png"),
      illcinq: require("./assets/img/couv coco insta.png"),
      illsix: require("./assets/img/zako insta.png"),
      illsept: require("./assets/img/buste.png"),
      illhuit: require("./assets/img/pigeon.png"),
      illneuf: require("./assets/img/stickers.png"),
      aniun: require("./assets/img/norbocosmo.gif"),
      anideux: require("./assets/img/2019.gif"),
      anitrois: require("./assets/img/mop.gif"),
      aniquatre: require("./assets/img/Oeuf.gif"),
      anicinq: require("./assets/img/norbert150.gif"),
      anisix: require("./assets/img/mini reggie.gif"),
      anisept: require("./assets/img/gribouvideo.png"),
      anihuit: require("./assets/img/mini peko.gif"),
      anineuf: require("./assets/img/trutrutruches.gif"),
      devun: require("./assets/img/Capture d’écran de 2019-03-19 10-49-00.png"),
      devdeux: require("./assets/img/27.gif"),
      devtrois: require("./assets/img/campng.png"),
      devquatre: require("./assets/img/memoire.png"),
      devcinq: require("./assets/img/prologueplus.png"),
      devsix: require("./assets/img/gamifyeu.png"),
      graun: require("./assets/img/tourbi.gif"),
      gradeux: require("./assets/img/passe.gif"),
      gratrois: require("./assets/img/fin.gif"),
      graquatre: require("./assets/img/euro2.gif"),
      gracinq: require("./assets/img/cwj.png"),
      grasept: require("./assets/img/starta.png"),
      site: "http://pekolio.com/rubiks",
      voir: true,
      see: false,
      pixel: false,
      gribou: false,
      illu: false,
      anim: false,
      dev: false,
      graph: false,
      keys: { 37: 1, 38: 1, 39: 1, 40: 1 },
      panels: [
        {
          title: "panel 1",
          coco: "CORENTIN PELAPRAT",
          co: "Full-stack developer, Web designer, Illustrator",
          card: "hidden"
        },
        {
          title: "panel 2",
          card: "one"
        },
        {
          title: "panel 3",
          card: "two"
        },
        {
          title: "panel 4",
          card: "tree"
        },
        {
          title: "panel 4",
          card: "four"
        }
      ]
    };
  },
  components: {
    Folio
  },
  methods: {
    preventDefault(e) {
      e = e || window.event;
      if (e.preventDefault) e.preventDefault();
      e.returnValue = false;
    },

    preventDefaultForScrollKeys(e) {
      if (this.keys[e.keyCode]) {
        this.preventDefault(e);
        return false;
      }
    },

    disableScroll() {
      if (window.addEventListener)
        // older FF
        window.addEventListener("DOMMouseScroll", this.preventDefault, false);
      window.onwheel = this.preventDefault; // modern standard
      window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
      window.ontouchmove = this.preventDefault; // mobile
      document.onkeydown = this.preventDefaultForScrollKeys;
    },

    enableScroll() {
      if (window.removeEventListener)
        window.removeEventListener(
          "DOMMouseScroll",
          this.preventDefault,
          false
        );
      window.onmousewheel = document.onmousewheel = null;
      window.onwheel = null;
      window.ontouchmove = null;
      document.onkeydown = null;
    },
    pixol() {
      this.pixel = !this.pixel;
      if (this.pixel == true) {
        this.disableScroll();
      } else {
        this.enableScroll();
      }
    },
    gribouz() {
      this.gribou = !this.gribou;
      if (this.gribou == true) {
        this.disableScroll();
      } else {
        this.enableScroll();
      }
    },
    illustr() {
      this.illu = !this.illu;
      if (this.illu == true) {
        this.disableScroll();
      } else {
        this.enableScroll();
      }
    },
    anima() {
      this.anim = !this.anim;
      if (this.anim == true) {
        this.disableScroll();
      } else {
        this.enableScroll();
      }
    },
    lien() {
      var that = this;
      console.log("run");
      if (
        that.devun ==
        require("./assets/img/Capture d’écran de 2019-03-19 10-49-00.png")
      ) {
        that.site = "http://pekolio.com/rubiks";
        that.voir = true;
      } else if (that.devun == require("./assets/img/campng.png")) {
        that.site = "http://pekolio.com";
        that.voir = true;
      } else if (that.devun == require("./assets/img/memoire.png")) {
        that.site = "http://pekolio.com/memoire";
        that.voir = true;
      } else if (that.devun == require("./assets/img/prologueplus.png")) {
        that.voir = false;
      } else if (that.devun == require("./assets/img/gamifyeu.png")) {
        that.site = "https://gamifyeu.org/";
        that.voir = true;
      } else if (that.devun == require("./assets/img/27.gif")) {
        that.site = "http://pekolio.com/boucho";
        that.voir = true;
      }
    },
    vid() {
      var that = this;
      console.log("run");
      if (that.aniun == require("./assets/img/gribouvideo.png")) {
        that.see = true;
      } else that.see = false;
    },
    deve() {
      this.dev = !this.dev;
      if (this.dev == true) {
        this.disableScroll();
      } else {
        this.enableScroll();
      }
    },
    graphi() {
      this.graph = !this.graph;
      if (this.graph == true) {
        this.disableScroll();
      } else {
        this.enableScroll();
      }
    },
    responsive() {
      var that = this;
      if (window.innerWidth < 845 || window.innerHeight < 500) {
        that.mobile = true;
        that.pc = false;
        if (that.mob == false) {
          window.removeEventListener("scroll", that.scrolling);
          that.$nextTick(that.pinContainerScene);
        }
      } else if (window.innerWidth > 845 || window.innerHeight > 500) {
        that.mobile = false;
        that.mob = false;
        that.on = false;
        if (that.pc == false) {
          window.addEventListener("scroll", that.scrolling);
          that.$nextTick(that.pinContainerScene);
        }
      }
    },
    scrolling() {
      var ScrollTop = parseInt(document.documentElement.scrollTop);
      var x = 400;
      if (window.innerHeight < 750 && window.innerHeight > 651) {
        x = 370;
      } else if (window.innerHeight < 650 && window.innerHeight > 551) {
        x = 340;
      } else if (window.innerHeight < 550 && window.innerHeight > 451) {
        x = 200;
      } else if (window.innerHeight < 450 && window.innerHeight > 351) {
        x = 180;
      } else if (window.innerHeight < 350 && window.innerHeight > 251) {
        x = 160;
      } else if (window.innerHeight < 250 && window.innerHeight > 151) {
        x = 100;
      } else if (window.innerHeight < 150 && window.innerHeight > 51) {
        x = 50;
      }
      if (ScrollTop > x) {
        var that = this;
        const etape = window.pageYOffset;
        setTimeout(function() {
          const etape2 = window.pageYOffset;
          if (etape > etape2) {
            that.norbert = require("../src/assets/img/norbertcourtgauche.gif");
          } else if (etape < etape2) {
            that.norbert = require("../src/assets/img/norbertcourt.gif");
          }
        }, 30);
        if (that.timer !== null) {
          clearTimeout(that.timer);
        }
        that.timer = setTimeout(function() {
          that.norbert = require("../src/assets/img/norbert.gif");
        }, 150);
      }
    },
    pinContainerScene() {
      var that = this;
      that.pc = true;
      that.mob = true;
      const Length = this.panels.length;

      if (that.mobile == false) {
        const tl = new this.$gsap.TimelineMax();

        tl.fromTo(
          `div.essai`,
          0.05,
          { y: "-1000%", opacity: 0 },
          {
            opacity: 1,
            y: "-450%"
          }
        ),
          tl.fromTo(
            `div.essai2`,
            0.05,
            { y: "-1000%", opacity: 0 },
            {
              opacity: 1,
              y: "-400%"
            }
          ),
          tl.add([
            TweenMax.fromTo(
              `div.mont1`,
              2,
              { x: "0%" },
              {
                x: "-10%"
              }
            ),
            TweenMax.fromTo(
              `div.mont2`,
              2,
              { x: "0%" },
              {
                x: "-4%"
              }
            ),
            TweenMax.fromTo(
              `div.sol`,
              2,
              { x: "0%" },
              {
                x: "-50%"
              }
            ),
            TweenMax.fromTo(
              `div.pinContainer`,
              2,
              { x: "0%" },
              {
                x: "-400%",
                y: "0%"
              }
            )
          ]);

        const scene = new this.$scrollmagic.Scene({
          triggerElement: ".pinContainer",
          triggerHook: "onLeave",
          duration: `${Length * 250}%`
        })
          .setPin(".pinContainer")
          .setTween(tl);

        this.$ksvuescr.$emit("addScene", "pinContainerScene", scene);
      } else if (that.mobile == true && that.on == false) {
        this.$ksvuescr.$emit("destroy");
      }
    }
  },
  destroyed() {
    this.$ksvuescr.$emit("destroy");
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/App.vue